module.exports = __webpack_public_path__ + "img/maintenance.08c16c53.png";